var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29.8 26.1",
    style: {
      enableBackground: "new 0 0 29.8 26.1"
    },
    xmlSpace: "preserve",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.2,26.1h-7.1V14.2h7.1V26.1z M17.5,24.6h4.2v-8.9h-4.2V24.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "27,26.1 2.8,26.1 2.8,12.1 4.3,12.1 4.3,24.6 25.5,24.6 25.5,12.1 27,12.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.7,21.3H6.6v-7.1h8.1V21.3z M8.1,19.9h5.2v-4.2H8.1V19.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.6,12.8c-1.5,0-2.8-0.7-3.5-1.9c-0.8,1.1-2.1,1.9-3.5,1.9s-2.8-0.7-3.5-1.9c-0.8,1.1-2.1,1.9-3.5,1.9 c-1.5,0-2.8-0.7-3.5-1.9c-0.8,1.1-2.1,1.9-3.5,1.9C1.9,12.8,0,10.9,0,8.5V8.3L4.7,0h20.4l4.7,8.3v0.2 C29.8,10.9,27.9,12.8,25.6,12.8z M21.3,8.5h1.5c0,1.6,1.3,2.8,2.8,2.8c1.5,0,2.7-1.2,2.8-2.6l-4.1-7.3H5.6L1.5,8.7 c0.1,1.5,1.3,2.6,2.8,2.6c1.6,0,2.8-1.3,2.8-2.8h1.5c0,1.6,1.3,2.8,2.8,2.8c1.6,0,2.8-1.3,2.8-2.8h1.5c0,1.6,1.3,2.8,2.8,2.8 S21.3,10.1,21.3,8.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 7.6,
    className: "st0",
    width: 28.4,
    height: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.2,
    y: 0.7,
    className: "st0",
    width: 1.5,
    height: 7.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.9,
    y: 3.9,
    transform: "matrix(0.2893 -0.9572 0.9572 0.2893 1.9646 11.9145)",
    className: "st0",
    width: 8.2,
    height: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 0.6,
    transform: "matrix(0.9573 -0.2892 0.2892 0.9573 -0.4503 6.2211)",
    className: "st0",
    width: 1.5,
    height: 8.2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorAdmin);
export default __webpack_public_path__ + "static/media/vendor-admin.95d67850.svg";
export { ForwardRef as ReactComponent };